import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() { this._bound = this._onClickOutside.bind(this) }

  toggle(event) { event.stopPropagation(); this.menuTarget.classList.contains("hidden") ? (this.menuTarget.classList.remove("hidden"), document.addEventListener("click", this._bound)) : this.close() }
  close() { this.menuTarget.classList.add("hidden"); document.removeEventListener("click", this._bound) }
  _onClickOutside(event) { if (!this.element.contains(event.target)) this.close() }
}